import './tailwind-main.css';
import './ecb-app-main.scss';

import Alpine from 'alpinejs';
//import persist from '@alpinejs/persist';

// Import Swiper
import Swiper from 'swiper';
// import 'swiper/swiper-bundle.css';
import { Navigation, Pagination, Scrollbar, Autoplay } from 'swiper/modules';

import '../components/alp-carousel';
import '../components/alp-header';
import '../components/alp-portfolio';

window.Alpine = Alpine;
window.Swiper = Swiper;
Swiper.use([Navigation, Pagination, Scrollbar, Autoplay]);

// Alpine.plugin(persist);
Alpine.start();

